import React, { ComponentProps, PropsWithChildren } from 'react';
import { Tabs as AntTabs } from 'antd';

type AntdPaneProps = ComponentProps<typeof AntTabs.TabPane>;

export const Pane = ({ tab, ...props }: PropsWithChildren<AntdPaneProps>) => {
  // NOTE: antd's Tabs reads `tab` off this element and maps it to the pane
  // label, so anything done with it here has no effect.
  return <AntTabs.TabPane {...props} />;
};
